import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

interface ICompetencyOption {
  id: number
  value: number
  description: string
}

export class CompetencyOption extends Model<ICompetencyOption> {
  static urlRoot() {
    return '/competencies/competency_options'
  }

  constructor(data: ICompetencyOption) {
    super(data)

    makeObservable(this, {
      value: computed,
    })
  }

  get value(): number {
    return this.attributes.value
  }
}
